import React from 'react';

import appContent from '@/services/content/appContent.typed';
import {twx} from '@/utils/tailwindUtils';

import AutoDeliveryDcxSectionButton from './AutoDeliveryDcxSectionButton';

interface AutoDeliveryDcxOrderHeaderProps {
    titleClassName?: string;
    isEditAllowed?: boolean;
    isUpdateDisabled?: boolean;
    headingAs?: React.ElementType;
    className?: string;
    isCompact?: boolean;
}

const AutoDeliveryDcxOrderHeader = ({
    titleClassName,
    isEditAllowed,
    isUpdateDisabled,
    headingAs,
    className,
    isCompact,
}: AutoDeliveryDcxOrderHeaderProps) => {
    const HeadingComponent = headingAs || 'h1';
    const {yourOrderTitle, yourOrderUpdateItemsButton} =
        appContent.getAutoDeliveryContent()?.extendedDetailsContent || {};

    return (
        <div className={twx('flex items-center justify-between gap-2', className)}>
            <HeadingComponent
                className={twx(
                    'mb-0 overflow-hidden text-ellipsis whitespace-nowrap font-bold ml:text-primary',
                    isCompact ? 'text-20 leading-[28px]' : 'text-32 leading-[42px]',
                    titleClassName
                )}
            >
                {yourOrderTitle}
            </HeadingComponent>
            {isEditAllowed && (
                <AutoDeliveryDcxSectionButton button={yourOrderUpdateItemsButton} disabled={isUpdateDisabled} />
            )}
        </div>
    );
};

export default AutoDeliveryDcxOrderHeader;
